import React from "react";
import { Box, IconButton, Link, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { Link as RouterLink } from "react-router-dom";

// What an announcement looks like — shared by the banner at the top of the app and the preview
// in Admin → Announcements, so the preview is exactly what users get. Explicit light colours on
// purpose: the MUI palette is "dark", and a default Alert renders unreadable ink here (CLAUDE.md).
export const BANNER_COLORS = {
  info: { bg: "#eff6ff", border: "#93c5fd", ink: "#1e3a8a", icon: "#1d4ed8" },
  warning: { bg: "#fffbeb", border: "#fcd34d", ink: "#78350f", icon: "#b45309" },
};

const SiteBannerView = ({ banner, onClose = null }) => {
  if (!banner) return null;
  const c = BANNER_COLORS[banner.style] || BANNER_COLORS.info;
  const Icon = banner.style === "warning" ? WarningAmberOutlinedIcon : InfoOutlinedIcon;
  const url = banner.linkUrl || "";
  const internal = url.startsWith("/") && !url.startsWith("//");
  const label = banner.linkLabel || "Read more";
  return (
    <Box
      role="status"
      data-testid="site-banner"
      sx={{
        display: "flex", alignItems: "center", gap: 1.25, px: 2, py: 0.75,
        background: c.bg, borderBottom: `1px solid ${c.border}`, color: c.ink,
      }}
    >
      <Icon fontSize="small" sx={{ color: c.icon, flexShrink: 0 }} />
      {/* Plain text: the message is rendered as text, never as HTML. */}
      <Typography variant="body2" sx={{ color: c.ink, flexGrow: 1, whiteSpace: "pre-wrap" }}>
        {banner.message}
        {url ? (
          <>
            {" "}
            <Link
              {...(internal
                ? { component: RouterLink, to: url }
                : { href: url, target: "_blank", rel: "noopener noreferrer" })}
              sx={{ color: c.ink, fontWeight: 700, textDecorationColor: c.ink }}
            >
              {label}
            </Link>
          </>
        ) : null}
      </Typography>
      {onClose ? (
        <IconButton size="small" aria-label="Close announcement" onClick={onClose} sx={{ color: c.ink }} data-testid="site-banner-close">
          <CloseIcon fontSize="small" />
        </IconButton>
      ) : null}
    </Box>
  );
};

export default SiteBannerView;
